import { ApplicationRef, Component, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validator, ValidatorFn, Validators } from '@angular/forms';
import { BryntumGridComponent, BryntumGridModule } from '@bryntum/grid-angular';
import * as ngrx from '@ngrx/store';
import { IRootState } from '../../../../../app.config';
import { ToasterService } from '../../../../../../shared/toaster/toaster.service';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlobStorageService } from '../../../../../../shared/blob-storage/blob-storage.service';
import { selectUserDivision } from '../../../../../../shared/user/user.reducer';
import { forkJoin, from, Subscription } from 'rxjs';
import ContainerSize from '../../../../../../shared/Container/model/ContainerSize';
import ContainerType from '../../../../../../shared/Container/model/ContainerType';
import { FreightPayer } from '../../../../../../shared/freight-payers/models/FreightPayer';
import { Division } from '../../../../../../shared/divisons/models/Division';
import { FreightPayersService } from '../../../../../../shared/freight-payers/freight-payers.service';
import { ContainerService } from '../../../../../../shared/Container/container.service';
import { DevanManagementService } from '../../../../../../shared/Container/devan/devan-management.service';
import { AbstractContainerJobTypeHelper } from '../../../../../../shared/Container/Helper/AbstractContainerJobTypeHelper';
import { ContainerJobDefault } from '../../../../../../shared/Container/model/ContainerJobDefault';
import { LoadUnloadType } from '../../../../../../shared/Container/model/LoadUnloadType';
import { ColumnStore, DateHelper, EventHelper, Grid, ObjectHelper, Store, Widget } from '@bryntum/grid';
import { FormatString } from '../../../../../../shared/constant/format-string';
import { BryntumWidgetBuilderService } from '../../../../../../shared/bryntum/bryntum-widget-builder.service';
import { BryntumGridConfigurationBuilderService } from '../../../../../../shared/bryntum/bryntum-grid-configuration-builder.service';
import { ContainerNumberHelper } from '../../../../../../shared/Container/Helper/ContainerNumberHelper';
import { JobTypeEnum } from '../../../../../../shared/Container/enum/JobTypeEnum';
import { VesselVisit } from '../../../../../../shared/Container/model/VesselVisit';
import { GridRowItem } from '../../../../../../shared/Container/model/GridRowItem';
import { JobManualBillingEnum } from '../../../../../../shared/Container/model/JobManualBillingEnum';
import { dateLessThanValidator } from '../../../../../../shared/validators/date-less-than.validator';
import { dateGreaterThanValidator } from '../../../../../../shared/validators/date-greater-than.validator';
import { ContainerTypeEnum } from '../../../../../../shared/Container/enum/ContainerTypeEnum';
import { CommonModule } from '@angular/common';
import { DefaultType } from '../../../../../../shared/form-defaults/models/DefaultType';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateContainerJobBasicsComponent } from './container-job-basics-form/container-job-basics-form.component';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateContainerJobRequestFactory } from '../../../../../../shared/Container/Helper/CreateContainerJobRequestFactory';
import UploadAttachment from '../../../../../../shared/Jobbing/models/UploadAttachment';
import { BillingData } from '../../../../../../shared/Container/model/BillingData';
import { ParseStrings } from '../../../../../../shared/constant/parse-strings';
import { BulkUpsertItemsComponent } from '../../../../../../shared/Container/modals/bulk-upsert-items/bulk-upsert-items.component';
import { ContainerDepotHubDataFormComponent } from './container-depot-hub-data-form/container-depot-hub-data-form.component';
import { ContainerJobAddressFormComponent } from "./container-job-address-form/container-job-address-form.component";
import { ContainerJobPackPropertiesComponent } from './container-job-pack-properties/container-job-pack-properties.component';
import { ContainerPortDataComponent } from './container-port-data/container-port-data.component';
import { ContainerJobDevanPropertiesComponent } from './container-job-devan-properties/container-job-devan-properties.component';
import { ContainerAdditionalPropertiesComponent } from './container-additional-properties/container-additional-properties.component';
import { FormDefaultsService } from '../../../../../../shared/form-defaults/form-defaults.service';
import { FormDefaultModel } from '../../../../../../shared/form-defaults/models/FormDefaultModel';
import { MogoDropzoneComponent } from '../../../../../../shared/mogo-dropzone/mogo-dropzone.component';
import { GoogleMapsService } from '../../../../../../shared/google-maps/google-maps.service';
import { Router } from '@angular/router';
import { setLoadingState } from '../../../../../../shared/app-configuration/app-configuration.actions';
import { containerJobDateValidator } from './container-job-create.validator';
import { wholeNumberValidator } from '../../../../../../shared/validators/whole-number.validator';
import { HazardCode } from '../../../../../../shared/Container/model/HazardCode';

@Component({
  selector: 'app-container-job-upsert-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    BryntumGridModule,
    NgSelectModule,
    CreateContainerJobBasicsComponent,
    ContainerDepotHubDataFormComponent,
    ContainerJobAddressFormComponent,
    ContainerJobPackPropertiesComponent,
    ContainerPortDataComponent,
    ContainerJobDevanPropertiesComponent,
    ContainerAdditionalPropertiesComponent,
    MogoDropzoneComponent
  ],
  templateUrl: './container-job-upsert-form.component.html',
  styleUrls: ['./container-job-upsert-form.component.scss']
})
export class ContainerJobUpsertFormComponent {

  @ViewChild('grid') gridComponent!: BryntumGridComponent;

  abstractContainerJobTypeHelper: AbstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();
  availableHazardCodes: any[] = [];
  availableDevanTypes: string[] = [];
  availablePackTypes: string[] = [];
  availableDoorDirections: string[] = [];
  containerChargesSub$: Subscription | undefined;
  containerSizes: ContainerSize[] = [];
  containerTypes: ContainerType[] = [];
  containerTypeSub$: Subscription | undefined;
  containerJobDefault: ContainerJobDefault | null = null;
  createContainerJobForm!: FormGroup;
  defaultClienteleFaf: number = 0;
  divisions: Division[] = [];
  filterOption: 'Physical' | 'Compliance' | 'Billing' | 'All' = 'Physical'
  freightPayerSub$: Subscription | undefined;
  freightPayers: FreightPayer[] = [];
  formDefaultValues: any | null;
  gridColumn: any[] = [];
  isInitialized: boolean = false;
  isSaving: boolean = false;
  jobTypeSub$: Subscription | undefined;
  loadUnloadTypes: LoadUnloadType[] = [];
  userDivision: Division | null = null;
  fullLegOnlySub$: Subscription | undefined;
  liveLoadSub$: Subscription | undefined;
  fullRequestedDeliveryDateSub$: Subscription | undefined;
  intermodalVesselEtaEtdDateSub$: Subscription | undefined;
  inlandPortSub$: Subscription | undefined;
  intermodalMtRequestedDeliveryDateSub$: Subscription | undefined;
  isHazmatSub$: Subscription | undefined;
  isDevanSub$: Subscription | undefined;
  isPackSub$: Subscription | undefined;
  plannedDevanDateSub$: Subscription | undefined;
  mtRequestedDeliveryDateSub$: Subscription | undefined;
  resettingForm: boolean = false;
  vesselEtaEtdDateSub$: Subscription | undefined;
  isFormReady: boolean = false;

  gridStore: Store = new Store({
    data: [],
  });
  gridConfig = {
    id: 'theGrid',
    rowHeight: 50,
    height: '30vh',
    width: '100%',
    enableTextSelection: true,
    features: {
      filterBar: true,
    },
    selectionMode: {
      cell: true,
      row: true,
    },
    listeners: {
      paint: ({ firstPaint, source }: { firstPaint: boolean; source: Widget }) => {
        if (firstPaint) {
          EventHelper.on({
            element: source.element,
            delegate: 'button.clearfilter',
            click: (event: any) => {
              event.stopPropagation();
              this.gridStore.clearFilters();
            },
            capture: true,
            thisObj: this
          })
        }
      },
    },
    store: this.gridStore,
    tbar: null
  };

  constructor(
    private readonly fb: FormBuilder,
    private readonly store$: ngrx.Store<IRootState>,
    private readonly freightPayerService: FreightPayersService,
    private readonly containerService: ContainerService,
    private readonly devanManagementService: DevanManagementService,
    private readonly toastr: ToasterService,
    private readonly modalService: NgbModal,
    private readonly downloadBlobService: BlobStorageService,
    private readonly bryntumGridConfigBuilderService: BryntumGridConfigurationBuilderService,
    private readonly bryntumWidgetBuilderService: BryntumWidgetBuilderService,
    private readonly formDefaultService: FormDefaultsService,
    private readonly googleMapsService: GoogleMapsService,
    private readonly router: Router,
    private readonly applicationRef: ApplicationRef
    // private readonly assetLoaderService: AssetLoaderService,
  ) { }

  ngOnInit() {
    this.store$.select(selectUserDivision).subscribe((userDivision) => {
      if (!userDivision) {
        return;
      }
      this.userDivision = {
        name: userDivision.name,
        regionId: userDivision.id
      };
    });
    const freightPayers$ = this.freightPayerService.search();
    const dangerousGoodsCodes$ = this.containerService.getHazardCodes();
    const loadUnloadTypes$ = this.containerService.getLoadUnloadTypes();
    const containerSizes$ = this.containerService.getContainerSizes();
    const containerTypes$ = this.containerService.getContainerTypes();
    const divisions$ = this.containerService.getJobDivisions();
    const devanTypes$ = this.devanManagementService.getDevanType(true);
    this.availableDoorDirections = this.containerService.getDoorDirections();

    forkJoin({
      dangerousGoodsCodes: dangerousGoodsCodes$,
      freightPayers: freightPayers$,
      loadUnloadTypes: loadUnloadTypes$,
      containerSizes: containerSizes$,
      containerTypes: containerTypes$,
      divisions: divisions$,
      devanTypes: devanTypes$,
    }).subscribe((result) => {
      this.store$.dispatch(setLoadingState({ isLoading: true }));
      
      this.availableHazardCodes = result.dangerousGoodsCodes.sort((a, b) =>
        a.name.localeCompare(b.name)
      ).map(a => { return { value: a.id, text: a.alias } });
      this.availableDevanTypes = result.devanTypes.filter((x: any) => x.isForDevan).map((type: any) => type.name);
      this.availablePackTypes = result.devanTypes.filter((x: any) => x.isForPack).map((type: any) => type.name);
      this.freightPayers = result.freightPayers;
      this.loadUnloadTypes = result.loadUnloadTypes;
      this.containerSizes = result.containerSizes;
      this.containerTypes = result.containerTypes;
      this.divisions = result.divisions;

      this.gridColumn = this.getColumnGrids();

      this.setClearForm();
      this.isInitialized = true;
      this.isFormReady = true;
      this.store$.dispatch(setLoadingState({ isLoading: false }));
    });
  }

  onBack() {
    this.router.navigate(['app/containers/home']);
  }

  setClearForm(preserveFreightPayer: boolean = false) {
    this.resettingForm = true;
    const getDepotHubFormGroup = () => this.fb.group({
      mtLocation: this.fb.control(null, [Validators.required]),
      releaseAcceptNo: this.fb.control(null),
      releaseAcceptActive: this.fb.control(null),
      inboundHub: this.fb.control(null),
      outboundHub: this.fb.control(null),
      mtRequestedDeliveryDate: this.fb.control(null),
    });

    const getAddressGroup = () => this.fb.group({
      address: this.fb.group({
        addressSelection: this.fb.group({
          masterContactAddressId: this.fb.control({
            masterContactId: null,
            masterContactName: null,
          })
        }),
      }),
      loadDate: this.fb.control(new Date()),
      siteContact: this.fb.control(null),
      sitePhone: this.fb.control(null),
      siteEmail: this.fb.control(null, Validators.email),
    });

    const getPortDataFormGroup = () => this.fb.group({
      originPort: this.fb.control(null, [Validators.required]),
      onwardPort: this.fb.control(null),
      isUsingInlandPort: this.fb.control(false),
      vessel: this.fb.control(null),
      fromEtaEtdDate: this.fb.control(null),
      fullRequestedDeliveryDate: this.fb.control(null),
      receivalCommenceDate: this.fb.control(null),
      receivalCutoffDate: this.fb.control(null)
    });

    const divisionToBeSet = this.getCurrentDivisionIndex() !== -1 ? this.divisions[this.getCurrentDivisionIndex()] : this.divisions[0];

    this.createContainerJobForm = this.fb.group({
      containerBasics: this.fb.group({
        freightPayer: this.fb.control(preserveFreightPayer ? this.createContainerJobForm.get('containerBasics')!.value.freightPayer : null, [Validators.required]),
        jobType: this.fb.control(null, [Validators.required]),
        fullLegOnly: this.fb.control(false),
        liveLoad: this.fb.control(false),
        temperatureValue: this.fb.control(3),
        mpiInspectionRequired: this.fb.control(false),
        needsLift: this.fb.control(false),
        containerType: this.fb.control(this.containerTypes[0]),
        containerSize: this.fb.control(this.containerSizes[1]),
        isHighGauge: this.fb.control(false),
        isWideGauge: this.fb.control(false),
        loadUnloadType: this.fb.control(this.loadUnloadTypes[0]),
        billingDivision: this.fb.control(divisionToBeSet, [Validators.required]),
        orderNumber: this.fb.control(null, Validators.required),
        tswId: this.fb.control(null),
        ecn: this.fb.control(null),
        customerReference: this.fb.control(null),
        csrComments: this.fb.control(null),
        billingNotes: this.fb.control(null),
        requiresXray: this.fb.control(false),
        requiresWeigh: this.fb.control(false)
      }, { validators: control => {
        if (control.get('liveLoad')!.value && control.get('fullLegOnly')!.value) {
          return { liveLoadFullLegOnly: true };
        }
        return null;
      } }),
      division: this.fb.control(divisionToBeSet),
      driverNotes: this.fb.control(null, [Validators.maxLength(250)]),
      intermodalDivision: this.fb.control(divisionToBeSet),
      fromAddress: getAddressGroup(),
      toAddress: getAddressGroup(),
      portData: getPortDataFormGroup(),
      depotHub: getDepotHubFormGroup(),
      isDevan: this.fb.control(false),
      plannedDevanType: this.fb.control(null),
      plannedDevanDate: this.fb.control(null),
      isPack: this.fb.control(false),
      plannedPackType: this.fb.control(null),
      plannedPackDate: this.fb.control(null),
      intermodalToPortData: getPortDataFormGroup(),
      intermodalToAddress: getAddressGroup(),
      intermodalToContact: this.fb.control(null),
      intermodalToPhone: this.fb.control(null),
      intermodalToEmail: this.fb.control(null, Validators.email),
      intermodalDepotHubData: getDepotHubFormGroup(),

      //docs and dates here
      containerCharges: this.fb.group({
        description: this.fb.control(null),
        ratePerContainer: this.fb.control(null),
        fafRate: this.fb.control(null),
        chargeType: this.fb.control(JobManualBillingEnum.Automatic)
      }),
      containerSurcharges: this.fb.group({
        surcharges: this.fb.array([]),
        grandTotal: this.fb.control(0),
      }),

      //Files
      attachments: this.fb.control([]),
      bacc: this.fb.control([]),
    });

    this.applyFormValueSubscribers();
    this.applyCorrectValidations();

    setTimeout(() => {
      this.resettingForm = false;
    }, 200);
  }

  getFormPartial = (formPath: string) => this.createContainerJobForm.get(formPath) as FormGroup;
  getCurrentDivisionIndex = () => this.divisions.findIndex((division) => division.regionId === this.userDivision!.regionId);
  getSelectedJobType = () => this.createContainerJobForm.get('containerBasics.jobType') && this.createContainerJobForm.get('containerBasics.jobType')!.value !== null ? this.createContainerJobForm.get('containerBasics.jobType')!.value.id as JobTypeEnum : null;
  showFromAddress = () => this.abstractContainerJobTypeHelper.isOutboundJob(this.getSelectedJobType()) || this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) || this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType()) || this.abstractContainerJobTypeHelper.isIntermodalJob(this.getSelectedJobType());
  showToAddress = () => this.abstractContainerJobTypeHelper.isInboundJob(this.getSelectedJobType()) || this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType());
  showPortData = () => this.getSelectedJobType() !== null && !this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType());
  isInboundJob = () => this.abstractContainerJobTypeHelper.isInboundJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType());
  isOutboundJob = () => this.abstractContainerJobTypeHelper.isOutboundJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType());
  isSeaJob = () => this.abstractContainerJobTypeHelper.isInboundJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) && !this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType());
  isIntermodalJob = () => this.abstractContainerJobTypeHelper.isIntermodalJob(this.getSelectedJobType());
  isFullLegOnly = () => this.createContainerJobForm.value.containerBasics.fullLegOnly;
  getSelectedDivision = () => this.createContainerJobForm.get('division') && this.createContainerJobForm.get('division')!.value !== null ? this.createContainerJobForm.get('division')!.value as Division : null;
  getSelectedArrivingLegDivision = () => this.createContainerJobForm.get('intermodalDivision') && this.createContainerJobForm.get('intermodalDivision')!.value !== null ? this.createContainerJobForm.get('intermodalDivision')!.value as Division : null;
  getSelectedVessel = () => this.createContainerJobForm.get('portData.vessel') && this.createContainerJobForm.get('portData.vessel')!.value !== null ? this.createContainerJobForm.get('portData.vessel')!.value as VesselVisit : null;
  getVesselEtaEtdDate = () => this.createContainerJobForm.get('portData.fromEtaEtdDate') && this.createContainerJobForm.get('portData.fromEtaEtdDate')!.value !== null ? this.createContainerJobForm.get('portData.fromEtaEtdDate')!.value as Date : null;
  getVesselFullRequestedDeliveryDate = () => this.createContainerJobForm.get('portData.fullRequestedDeliveryDate') && this.createContainerJobForm.get('portData.fullRequestedDeliveryDate')!.value !== null ? this.createContainerJobForm.get('portData.fullRequestedDeliveryDate')!.value as Date : null;
  getIntermodalVesselEtaEtdDate = () => this.createContainerJobForm.get('intermodalToPortData.fromEtaEtdDate') && this.createContainerJobForm.get('intermodalToPortData.fromEtaEtdDate')!.value !== null ? this.createContainerJobForm.get('intermodalToPortData.fromEtaEtdDate')!.value as Date : null;
  getVesselIntermodalFullRequestedDeliveryDate = () => this.createContainerJobForm.get('intermodalToPortData.fullRequestedDeliveryDate') && this.createContainerJobForm.get('intermodalToPortData.fullRequestedDeliveryDate')!.value !== null ? this.createContainerJobForm.get('intermodalToPortData.fullRequestedDeliveryDate')!.value as Date : null;
  getReceivalCommenceDate = () => this.createContainerJobForm.get('portData.receivalCommenceDate') && this.createContainerJobForm.get('portData.receivalCommenceDate')!.value !== null ? this.createContainerJobForm.get('portData.receivalCommenceDate')!.value as Date : null;
  getReceivalCutoffDate = () => this.createContainerJobForm.get('portData.receivalCutoffDate') && this.createContainerJobForm.get('portData.receivalCutoffDate')!.value !== null ? this.createContainerJobForm.get('portData.receivalCutoffDate')!.value as Date : null;
  isExportJob = () => this.abstractContainerJobTypeHelper.isExportJob(this.getSelectedJobType());
  isOnSiteJob = () => this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType());
  allowInvalidContainerNumber = () => this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) || this.isOnSiteJob() || this.abstractContainerJobTypeHelper.isRailJob(this.getSelectedJobType());
  CanSkipContainerNumber = () => (this.isExportJob() && !this.isFullLegOnly()) || this.isIntermodalJob();
  showDivision = () => this.abstractContainerJobTypeHelper.isInboundJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isOutboundJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isMoveJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isOnSiteJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isIntermodalJob(this.getSelectedJobType());

  showDevan = () => this.abstractContainerJobTypeHelper.isInboundJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isIntermodalJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isImportJob(this.getSelectedJobType());
  showPack = () => this.abstractContainerJobTypeHelper.isOutboundJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isIntermodalJob(this.getSelectedJobType()) ||
    this.abstractContainerJobTypeHelper.isExportJob(this.getSelectedJobType());

  private getColumnGrids() {
    return [
      {
        hidden: false,
        width: '8em',
        type: 'widget',
        align: 'center',
        hideable: false,
        resizable: false,
        draggable: false,
        widgets: [
          this.bryntumWidgetBuilderService.buildGridRowDeleteWidget(this.gridStore)
        ],
        headerRenderer: this.bryntumGridConfigBuilderService.getClearFilterActionHeaderButton(),
      },
      {
        field: 'containerNumber',
        text: 'Container No',
        flex: 2,
        renderer: ({ cellElement, value }: { cellElement: any, value: string }) => {
          const valid: boolean = this.CanSkipContainerNumber() && value.length === 0 ? true : ContainerNumberHelper.containerNumberIsValid(value);
          if (!valid) {
            cellElement.style.color = 'red';
            return `${value} *`
          }
          else {
            cellElement.style.color = 'black';
            return value;
          }
        },
        tooltipRenderer: ({ record }: { record: GridRowItem }) => {
          const valid: boolean = this.CanSkipContainerNumber() && record.containerNumber.length === 0 ? true : ContainerNumberHelper.containerNumberIsValid(record.containerNumber);
          if (!valid) {
            'Container number is INVALID.';
          }
          else {
            'Container number is valid.';
          }
        }
      },
      {
        id: 'orderNumber',
        field: 'orderNumber',
        text: 'Order Number',
        flex: 2,
      },
      { id: 'weight', field: 'weight', text: 'Weight', flex: 1 },
      {
        id: 'type',
        field: 'containerType',
        text: 'Type',
        flex: 1,
        editor: { type: 'dropdown', items: ['GP', 'HC', 'FR', 'OT', 'RF'] }
      },
      {
        id: 'size',
        field: 'containerSize',
        text: 'Size',
        flex: 1,
        editor: { type: 'dropdown', items: ['10FT', '20FT', '40FT', '45FT'] }
      },
      {
        id: 'devanType',
        field: 'devanType',
        text: 'Devan Type',
        flex: 1,
        hidden: true,
        editor: {
          type: 'dropdown',
          items: this.availableDevanTypes,
        }
      },
      { id: 'devanDate', field: 'devanDate', text: 'Devan date', type: 'date', format: FormatString.bryntumDate, flex: 1, hidden: true },
      {
        id: 'doorDirection',
        field: 'doorDirection',
        text: 'Door Dir',
        flex: 1,
        editor: { type: 'dropdown', items: this.availableDoorDirections }
      },
      {
        id: 'dg',
        field: 'dangerousGoods',
        text: 'DG Codes',
        flex: 1,
        editor: { type: 'dropdown', multiSelect: true, items: this.availableHazardCodes },
        renderer: (event: any) => {
          if (event.value && event.value.length > 0) {
            const hazardNames = this.availableHazardCodes.filter(hc => event.value.includes(hc.value)).map(hc => hc.text);
            return hazardNames.join(', ');
          } else {
            return '';
          }
        }
      },
      {
        id: 'pin',
        field: 'pin',
        text: 'PIN',
        flex: 1,
      },
      {
        id: 'express-pin',
        field: 'expressPin',
        text: 'Express PIN',
        flex: 1,
      },
      {
        id: 'grid_number_full',
        field: 'gridNumberFull',
        text: 'Grid # - Full',
        flex: 1,
        editor: {
          type: 'text',
          maxLength: 12
        }
      },
      {
        id: 'grid_number_mt',
        field: 'gridNumberMt',
        text: 'Grid # - MT',
        flex: 1,
        editor: {
          type: 'text',
          maxLength: 12
        }
      }
    ]
  }

  applyFormValueSubscribers() {
    this.liveLoadSub$?.unsubscribe();
    this.liveLoadSub$ = this.createContainerJobForm.get('containerBasics.liveLoad')!.valueChanges.subscribe(this.onLiveLoadChange);
    this.freightPayerSub$ = this.createContainerJobForm.get('containerBasics')!.get('freightPayer')!.valueChanges.subscribe(this.onFreightPayerChange);
    this.jobTypeSub$ = this.createContainerJobForm.get('containerBasics')!.get('jobType')!.valueChanges.subscribe(this.onJobTypeChange);
    this.containerTypeSub$ = this.createContainerJobForm.get('containerBasics')!.get('containerType')!.valueChanges.subscribe(this.onContainerTypeChange);
    this.fullLegOnlySub$ = this.createContainerJobForm.get('containerBasics')!.get('fullLegOnly')!.valueChanges.subscribe(this.onFullLegOnlyChange);
    this.inlandPortSub$ = this.createContainerJobForm.get('portData')!.get('isUsingInlandPort')!.valueChanges.subscribe(this.onInlandPortChange);
    this.isDevanSub$ = this.createContainerJobForm.get('isDevan')!.valueChanges.subscribe(this.onIsDevanChange);
    this.isPackSub$ = this.createContainerJobForm.get('isPack')!.valueChanges.subscribe(this.onIsPackChange);
    this.plannedDevanDateSub$ = this.createContainerJobForm.get('plannedDevanDate')!.valueChanges.subscribe(this.onPlannedDevanDateChange);
    this.containerChargesSub$ = this.createContainerJobForm.get('containerCharges')!.get('chargeType')!.valueChanges.subscribe(this.onContainerChargeChange);
    this.fullRequestedDeliveryDateSub$ = this.createContainerJobForm.get('portData')!.get('fullRequestedDeliveryDate')!.valueChanges.subscribe(this.onFullRequestedDeliveryDateChange);
    this.mtRequestedDeliveryDateSub$ = this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate')!.valueChanges.subscribe(this.onMtRequestDeliveryChange);
    this.intermodalMtRequestedDeliveryDateSub$ = this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate')!.valueChanges.subscribe(this.onIntermodalMtRequestDeliveryChange);
    this.vesselEtaEtdDateSub$ = this.createContainerJobForm.get('portData')!.get('fromEtaEtdDate')!.valueChanges.subscribe(this.onVesselEtaEtdDateChange);
    this.intermodalVesselEtaEtdDateSub$ = this.createContainerJobForm.get('intermodalToPortData')!.get('fromEtaEtdDate')!.valueChanges.subscribe(this.onIntermodalVesselEtaEtdDateChange);
  }

  onIsDevanChange = (isDevan: boolean): any => {
    if (isDevan) {
      this.createContainerJobForm.get('plannedDevanType')!.setValidators([Validators.required]);
      this.createContainerJobForm.get('plannedDevanDate')!.setValidators([Validators.required]);

      this.onFullRequestedDeliveryDateChange(this.createContainerJobForm.get('portData')!.get('fullRequestedDeliveryDate')!.value);
    } else {
      this.createContainerJobForm.get('plannedDevanType')!.clearValidators();
      this.createContainerJobForm.get('plannedDevanDate')!.clearValidators();
    }
    this.createContainerJobForm.get('plannedDevanType')!.updateValueAndValidity();
    this.createContainerJobForm.get('plannedDevanDate')!.updateValueAndValidity();
  }

  onIsPackChange = (isPack: boolean): any => {
    if (isPack) {
      this.createContainerJobForm.get('plannedPackType')!.setValidators([Validators.required]);
      this.createContainerJobForm.get('plannedPackDate')!.setValidators([Validators.required]);
      this.onMtRequestDeliveryChange(this.createContainerJobForm.get('portData')!.get('mtRequestedDeliveryDate')!.value);
    } else {
      this.createContainerJobForm.get('plannedPackType')!.clearValidators();
      this.createContainerJobForm.get('plannedPackDate')!.clearValidators();
    }
    this.createContainerJobForm.get('plannedPackType')!.updateValueAndValidity();
    this.createContainerJobForm.get('plannedPackDate')!.updateValueAndValidity();
  }

  onPlannedDevanDateChange = (value: Date | null) : void => {
    containerJobDateValidator(this.createContainerJobForm);
  }

  onInlandPortChange = (useInlandPort: boolean): any => {
    if (this.createContainerJobForm.get('portData')) {
      if (useInlandPort) {
        this.createContainerJobForm.get('portData')!.get('onwardPort')!.setValidators([Validators.required]);
      } else {
        this.createContainerJobForm.get('portData')!.get('onwardPort')!.clearValidators();
      }
      this.createContainerJobForm.get('portData')!.get('onwardPort')!.updateValueAndValidity();
    }
  }

  onHazmatChange = (isHazmat: any): any => {
    if (this.createContainerJobForm.get('additionalData')) {

      if (isHazmat) {
        this.createContainerJobForm.get('additionalData')!.get('hazmatCode')!.setValidators([Validators.required]);
      } else {
        this.createContainerJobForm.get('additionalData')!.get('hazmatCode')!.clearValidators();
      }
      this.createContainerJobForm.get('additionalData')!.get('hazmatCode')!.updateValueAndValidity();
    }
  }

  onContainerChargeChange = (chargeType: string): any => {
    if (this.createContainerJobForm.get('containerCharges')) {
      const containerCharge = this.createContainerJobForm.get('containerCharges');
      if (chargeType === JobManualBillingEnum.Manual) {
        containerCharge!.get('description')!.setValidators([Validators.required]);
        containerCharge!.get('ratePerContainer')!.setValidators([Validators.required]);
        containerCharge!.get('fafRate')!.setValidators([Validators.required]);
        containerCharge!.get('fafRate')!.patchValue(this.defaultClienteleFaf);
      } else {
        containerCharge!.get('description')!.clearValidators();
        containerCharge!.get('ratePerContainer')!.clearValidators();
        containerCharge!.get('fafRate')!.clearValidators();
        containerCharge!.get('fafRate')!.patchValue(null);
      }
      containerCharge!.get('description')!.updateValueAndValidity();
      containerCharge!.get('ratePerContainer')!.updateValueAndValidity();
      containerCharge!.get('fafRate')!.updateValueAndValidity();
    }
  }

  onContainerTypeChange = (containerValue: any) => {
    if (this.createContainerJobForm.get('containerBasics')) {

      if (containerValue !== null && containerValue.code === ContainerTypeEnum.Refrigerated) {
        this.createContainerJobForm.get('containerBasics')!.get('temperatureValue')!.setValidators([Validators.required]);
      } else {
        this.createContainerJobForm.get('containerBasics')!.get('temperatureValue')!.clearValidators();
      }
      this.createContainerJobForm.get('containerBasics')!.get('temperatureValue')!.updateValueAndValidity();

      this.createContainerJobForm.get('containerBasics')!.get('isHighGauge')!.patchValue(false, { emitEvent: false });
      this.createContainerJobForm.get('containerBasics')!.get('isHighGauge')!.updateValueAndValidity();
      this.createContainerJobForm.get('containerBasics')!.get('isWideGauge')!.patchValue(false, { emitEvent: false });
      this.createContainerJobForm.get('containerBasics')!.get('isWideGauge')!.updateValueAndValidity();
    }
  }

  onLiveLoadChange = (liveLoad: boolean) => {
    const basics = this.createContainerJobForm.get('containerBasics')!;
    const loadUnloadType = this.loadUnloadTypes.find(type => type.code === (liveLoad ? 'LUL' : ''));
    basics.get('loadUnloadType')!.setValue(loadUnloadType);
    const fullLegOnly = basics.get('fullLegOnly')!;
    if (liveLoad) {
      fullLegOnly.setValue(false);
      fullLegOnly.disable({ emitEvent: false });
    } else {
      fullLegOnly.enable({ emitEvent: false });
    }
  };

  ngOnDestroy() {
    this.liveLoadSub$?.unsubscribe();
  }

  onFullLegOnlyChange = (fullLegOnly: boolean) => {
    if (this.createContainerJobForm.get('depotHub') && this.createContainerJobForm.get('intermodalDepotHubData')) {
      if (fullLegOnly) {
        this.createContainerJobForm.get('depotHub')!.get('mtLocation')!.setValidators([Validators.required]);
        if (this.isIntermodalJob()) {
          this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtLocation')!.setValidators([Validators.required]);
          this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate')!.setValidators([Validators.required]);
        }
      } else {
        this.createContainerJobForm.get('depotHub')!.get('mtLocation')!.clearValidators();
        this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtLocation')!.clearValidators();

        this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate')!.clearValidators();
        this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate')!.clearValidators();

      }
      this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtLocation')!.updateValueAndValidity();
      this.createContainerJobForm.get('depotHub')!.get('mtLocation')!.updateValueAndValidity();

      this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate')!.updateValueAndValidity();
      this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate')!.updateValueAndValidity();
    }
  }

  onBaccFilesChange($event: any) {
    this.createContainerJobForm.patchValue({
      bacc: $event
    });
  }

  onAttachmentFilesChange($event: any) {
    this.createContainerJobForm.patchValue({
      attachments: $event
    });
  }

  onMtRequestDeliveryChange = (value: Date) => {
    if (this.createContainerJobForm.get('depotHub')) {
      const mtRequestedDeliveryDateControl = this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate');

      if (value) {
        const fromEtaEtdDate = this.getVesselEtaEtdDate();
        const fullRequestedDeliveryDate = this.getVesselFullRequestedDeliveryDate();

        mtRequestedDeliveryDateControl!.clearValidators();

        const validators = [];
        let mtRequestedDateValidators = [];

        if (!this.isFullLegOnly()) {
          mtRequestedDateValidators.push(Validators.required)
        }

        if (this.isInboundJob()) {
          if (fromEtaEtdDate) {
            validators.push(dateLessThanValidator(fromEtaEtdDate));
          }

          if (fullRequestedDeliveryDate) {
            validators.push(dateLessThanValidator(fullRequestedDeliveryDate));
            mtRequestedDateValidators.push(dateLessThanValidator(fullRequestedDeliveryDate));
          }
        } else {
          if (fromEtaEtdDate) {
            validators.push(dateGreaterThanValidator(fromEtaEtdDate));
          }

          if (fullRequestedDeliveryDate) {
            validators.push(dateGreaterThanValidator(fullRequestedDeliveryDate));
          }
        }

        mtRequestedDeliveryDateControl!.setValidators(validators);
      }

      mtRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
    }
  }

  onIntermodalMtRequestDeliveryChange = (value: Date) => {
    if (this.createContainerJobForm.get('intermodalDepotHubData')) {
      const mtRequestedDeliveryDateControl = this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate');

      if (value) {
        const fromEtaEtdDate = this.getIntermodalVesselEtaEtdDate();
        const fullRequestedDeliveryDate = this.getVesselIntermodalFullRequestedDeliveryDate();

        mtRequestedDeliveryDateControl!.clearValidators();

        const validators = [];
        let mtRequestedDateValidators: ValidatorFn[] = [];

        if (!this.isFullLegOnly()) {
          mtRequestedDateValidators.push()
        }

        if (fromEtaEtdDate) {
          validators.push(dateLessThanValidator(fromEtaEtdDate));
        }

        if (fullRequestedDeliveryDate) {
          validators.push(dateLessThanValidator(fullRequestedDeliveryDate));
        }

        mtRequestedDeliveryDateControl!.setValidators(mtRequestedDateValidators);
      }
      mtRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
    }
  }

  onVesselEtaEtdDateChange = (value: Date) => {
    if (value && this.createContainerJobForm.get('depotHub') && this.createContainerJobForm.get('portData')) {

      const mtRequestedDeliveryDateControl = this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate');
      const fullRequestedDeliveryDateControl = this.createContainerJobForm.get('portData')!.get('fullRequestedDeliveryDate');
      const receivalCommenceDateControl = this.createContainerJobForm.get('portData')!.get('receivalCommenceDate');
      const receivalCutoffDateControl = this.createContainerJobForm.get('portData')!.get('receivalCutoffDate');

      const fromEtaEtdDate = this.getVesselEtaEtdDate();
      const fullRequestedDeliveryDate = this.getVesselFullRequestedDeliveryDate();
      const receivalCommenceDate = this.getReceivalCommenceDate();
      const receivalCutoffDate = this.getReceivalCutoffDate();

      mtRequestedDeliveryDateControl!.clearValidators();
      fullRequestedDeliveryDateControl!.clearValidators();
      receivalCommenceDateControl!.clearValidators();
      receivalCutoffDateControl!.clearValidators();

      const validators = [];
      const receivalCommenceValidators = [];
      const receivalCutoffValidators = [];
      let mtRequestedDateValidators = [];

      if (this.isInboundJob()) {
        if (fromEtaEtdDate) {
          validators.push(dateLessThanValidator(fromEtaEtdDate));
        }

        if (fullRequestedDeliveryDate) {
          validators.push(dateLessThanValidator(fullRequestedDeliveryDate));
        }

        if (mtRequestedDeliveryDateControl!.value) {
          mtRequestedDateValidators.push(dateLessThanValidator(fromEtaEtdDate!));
          mtRequestedDateValidators.push(dateLessThanValidator(fullRequestedDeliveryDate!));
        }
      } else {
        if (fromEtaEtdDate) {

          if (mtRequestedDeliveryDateControl!.value) {
            mtRequestedDateValidators.push(dateGreaterThanValidator(fromEtaEtdDate));
          }

          receivalCommenceValidators.push(dateGreaterThanValidator(fromEtaEtdDate));
          receivalCutoffValidators.push(dateGreaterThanValidator(fromEtaEtdDate));
          validators.push(dateGreaterThanValidator(fromEtaEtdDate));
        }

        if (fullRequestedDeliveryDate && mtRequestedDeliveryDateControl!.value) {
          mtRequestedDateValidators.push(dateGreaterThanValidator(fullRequestedDeliveryDate));
        }

        if (receivalCommenceDate) {
          receivalCutoffValidators.push(dateLessThanValidator(receivalCommenceDate));
        }

        if (receivalCutoffDate) {
          receivalCommenceValidators.push(dateGreaterThanValidator(receivalCutoffDate));
        }
      }

      mtRequestedDeliveryDateControl!.setValidators(mtRequestedDateValidators);
      fullRequestedDeliveryDateControl!.setValidators(validators);
      receivalCommenceDateControl!.setValidators(receivalCommenceValidators);
      receivalCutoffDateControl!.setValidators(receivalCutoffValidators);

      mtRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
      fullRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
      receivalCommenceDateControl!.updateValueAndValidity({ emitEvent: false });
      receivalCutoffDateControl!.updateValueAndValidity({ emitEvent: false });
    }

    this.onVesselEtaEtdChange(value);
  }

  onIntermodalVesselEtaEtdDateChange = (value: Date) => {
    if (this.createContainerJobForm.get('intermodalDepotHubData')) {
      const mtRequestedDeliveryDateControl = this.createContainerJobForm.get('intermodalDepotHubData')!.get('mtRequestedDeliveryDate');

      if (value) {
        const fromEtaEtdDate = this.getVesselEtaEtdDate();
        const fullRequestedDeliveryDate = this.getVesselFullRequestedDeliveryDate();

        mtRequestedDeliveryDateControl!.clearValidators();

        const validators = [];
        let mtRequestedDateValidators: ValidatorFn[] = [];

        if (fromEtaEtdDate) {
          validators.push(dateLessThanValidator(fromEtaEtdDate));
        }

        if (fullRequestedDeliveryDate) {
          validators.push(dateLessThanValidator(fullRequestedDeliveryDate));
        }

        mtRequestedDeliveryDateControl!.setValidators(mtRequestedDateValidators);
      }

      mtRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
    }

    this.onIntermodalVesselEtaEtdChange(value);
  }

  onFullRequestedDeliveryDateChange = (value: Date) => {
    if (this.createContainerJobForm.get('depotHub')) {
      const fullRequestedDeliveryDateControl = this.createContainerJobForm.get('portData')!.get('fullRequestedDeliveryDate');
      const mtRequestedDeliveryDateControl = this.createContainerJobForm.get('depotHub')!.get('mtRequestedDeliveryDate');
      const isDevan = this.createContainerJobForm.get('isDevan')!.value;
      const devateDateControl = this.createContainerJobForm.get('plannedDevanDate');
      let doesMtDateNeedUpdate = false;

      if (value) {
        const fromEtaEtdDate = this.getVesselEtaEtdDate();
        const mtRequestedDeliveryDate = mtRequestedDeliveryDateControl!.value;

        fullRequestedDeliveryDateControl!.clearValidators();

        const validators = [];
        let mtRequestedDateValidators = [];
        let devanValidators = [];

        if (this.isInboundJob()) {
          if (isDevan) {
            devanValidators.push(dateLessThanValidator(value));
          }

          if (fromEtaEtdDate) {
            validators.push(dateLessThanValidator(fromEtaEtdDate));
            mtRequestedDateValidators.push(dateLessThanValidator(fromEtaEtdDate));
            doesMtDateNeedUpdate = true
          }

          if (mtRequestedDeliveryDate) {
            mtRequestedDateValidators.push(dateLessThanValidator(value));
            doesMtDateNeedUpdate = true
          }
        } else {
          if (fromEtaEtdDate) {
            validators.push(dateGreaterThanValidator(fromEtaEtdDate));
          }

          if (mtRequestedDeliveryDate) {
            mtRequestedDateValidators.push(dateLessThanValidator(value));
            doesMtDateNeedUpdate = true
          }
        }
        fullRequestedDeliveryDateControl!.setValidators(validators);
        mtRequestedDeliveryDateControl!.setValidators(mtRequestedDateValidators);
        devateDateControl!.setValidators(devanValidators);
      }

      fullRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
      mtRequestedDeliveryDateControl!.updateValueAndValidity({ emitEvent: false });
      devateDateControl!.updateValueAndValidity({ emitEvent: false });

      if (doesMtDateNeedUpdate) {
        this.onMtRequestDeliveryChange(mtRequestedDeliveryDateControl!.value);
      }
    }

  }

  onVesselEtaEtdChange = (value: Date) => {
    if (this.createContainerJobForm.get('intermodalToPortData') && this.createContainerJobForm.get('portData')) {
      const fromEtaEtdDateControl = this.createContainerJobForm.get('intermodalToPortData')!.get('fromEtaEtdDate');
      const fromEtaEtdDate = this.getIntermodalVesselEtaEtdDate();

      if (value) {

        if (fromEtaEtdDate) {
          if (value > fromEtaEtdDate) {
            fromEtaEtdDateControl!.setValidators(dateLessThanValidator(value));
          } else {
            fromEtaEtdDateControl!.clearValidators();
          }
        }
      } else {
        fromEtaEtdDateControl!.clearValidators();
      }
      fromEtaEtdDateControl!.updateValueAndValidity({ emitEvent: false });
    }
  }

  onIntermodalVesselEtaEtdChange = (value: Date) => {
    if (this.createContainerJobForm.get('portData') && this.createContainerJobForm.get('intermodalToPortData')) {
      const fromEtaEtdDateControl = this.createContainerJobForm.get('intermodalToPortData')!.get('fromEtaEtdDate');
      const fromEtaEtdDate = this.getVesselEtaEtdDate();

      if (value) {

        if (fromEtaEtdDate) {
          if (value < fromEtaEtdDate) {
            fromEtaEtdDateControl!.setValidators(dateLessThanValidator(fromEtaEtdDate));
          } else {
            fromEtaEtdDateControl!.clearValidators();
          }
        }
      } else {
        fromEtaEtdDateControl!.clearValidators();
      }
      fromEtaEtdDateControl!.updateValueAndValidity({ emitEvent: false });
    }
  }

  onJobTypeChange = (jobType: any) => {
    this.gridStore.data = [];

    if (jobType === null || ![JobTypeEnum.Import, JobTypeEnum.Export, JobTypeEnum.DomesticInbound, JobTypeEnum.DomesticOutbound].includes(jobType.id)) {
      this.createContainerJobForm.get('containerBasics.liveLoad')!.setValue(false);
    }

    if (jobType === null) {
      this.applyCorrectValidations(jobType);
      return;
    }
    if (this.formDefaultValues && this.formDefaultValues.containerBasics.jobType.id !== jobType.id) {
      this.setClearForm();
      this.createContainerJobForm.get('containerBasics')!.get('freightPayer')!.patchValue(this.formDefaultValues.containerBasics.freightPayer, { emitEvent: false });
      this.createContainerJobForm.get('containerBasics')!.get('jobType')!.patchValue(jobType, { emitEvent: false });
    }

    if (this.showDevan()) {
    }

    if (this.showPack()) {
    }
    this.applyCorrectValidations(jobType);
    this.onContainerTypeChange(this.formDefaultValues.containerBasics.containerType);
    this.createContainerJobForm.updateValueAndValidity();
  }

  onFreightPayerChange = (freightPayer: FreightPayer) => {
    if (freightPayer === null) {
      this.setDefaultFormValues(null);
      this.isInitialized = true;
      return;
    }

    this.isInitialized = true;
    if (!this.createContainerJobForm.value.containerBasics
      || !this.createContainerJobForm.value.containerBasics.freightPayer
      || this.createContainerJobForm.value.containerBasics.freightPayer.id !== freightPayer.clienteleId) {
      const defaultFaf$ = this.containerService.getDefaultFaf(freightPayer.clienteleId, this.createContainerJobForm.value.containerBasics.billingDivision.regionId);
      const containerJobDefault$ = this.formDefaultService.getFormDefaults(freightPayer.clienteleId, DefaultType.ContainerJob);

      forkJoin([defaultFaf$, containerJobDefault$]).subscribe(([defaultFaf, containerJobDefault]) => {
        if(containerJobDefault) {
          this.setDefaultFormValues({
            freightPayerId: freightPayer.clienteleId,
            data: containerJobDefault.formValueJson,
            containerJobDefaultId: 0,
            type: 'ContainerJob'
          });
        }
        this.defaultClienteleFaf = defaultFaf;
        this.isInitialized = true;
      });
    }
  }

  getDateFromNgbDate(date: NgbDate | null): Date | null {
    return date ? new Date(date.year, date.month - 1, date.day) : null;
  }

  private setDefaultFormValues(containerJobDefault: ContainerJobDefault | null) {
    this.isFormReady = false;
    this.containerJobDefault = containerJobDefault;
    // Check we got a valid ContainerJobDefault object and that the
    // data isnt the string representation of an empty object
    if (containerJobDefault && containerJobDefault.data !== '{}' && containerJobDefault.data !== '') {
      const defaultData = JSON.parse(containerJobDefault.data);
      if (defaultData && !ObjectHelper.isEmpty(defaultData)) {
        this.formDefaultValues = defaultData;

        this.createContainerJobForm.patchValue({
          containerBasics: defaultData.containerBasics || {},
          depotHub: {
            ...defaultData.depotHub,
            mtLocation: null
          },
          additionalData: defaultData.additionalData ? {
            ...defaultData.additionalData,
            firstNotifiedDate: defaultData.additionalData.firstNotifiedDate ? this.getDateFromNgbDate(defaultData.additionalData.firstNotifiedDate) : null,
            documentReceivedDate: defaultData.additionalData.documentReceivedDate ? this.getDateFromNgbDate(defaultData.additionalData.documentReceivedDate) : null
          } : {},
          containerCharges: defaultData.containerCharges || {},
          containerSurcharges: [],
          fromAddress: defaultData.fromAddress || {},
          portData: defaultData.portData ? {
            ...defaultData.portData,
            fullRequestedDeliveryDate: null,
            fromEtaEtdDate: null,
            vessel: null
          } : {},
          intermodalToPortData: defaultData.intermodalToPortData ? {
            ...defaultData.intermodalToPortData,
            vessel: null
          } : {},
          intermodalToAddress: defaultData.intermodalToAddress || {},
          intermodalDepotHubData: defaultData.intermodalDepotHubData || {},
          isDevan: defaultData.isDevan,
          plannedDevanType: defaultData.plannedDevanType,
          plannedDevanDate: defaultData.plannedDevanDate ? defaultData.plannedDevanDate : null,
          isPack: defaultData.isPack,
          plannedPackType: defaultData.plannedPackType,
          plannedPackDate: defaultData.plannedPackDate ? defaultData.plannedPackDate : null,
          toAddress: defaultData.toAddress || {},
        }, { emitEvent: false });

        const savedBasics = defaultData.containerBasics;
        const savedLoadUnloadType = savedBasics?.loadUnloadType;
        const liveLoad = savedBasics?.liveLoad ?? (savedLoadUnloadType?.code === 'LUL');
        this.createContainerJobForm.get('containerBasics.liveLoad')!.setValue(liveLoad);

        // Preserve non-live handling defaults, such as trailer swaps.
        if (!liveLoad && savedLoadUnloadType && savedLoadUnloadType.code !== 'LUL') {
          this.createContainerJobForm.get('containerBasics.loadUnloadType')!.setValue(savedLoadUnloadType);
        }
        this.onIsDevanChange(defaultData.isDevan);
        this.isFormReady = true;
        this.applicationRef.tick();

        const addressControl = this.createContainerJobForm.get('toAddress.address.addressSelection.masterContactAddressId');

        if (addressControl
          && defaultData.toAddress?.address?.addressSelection?.masterContactAddressId?.masterContactId
          && defaultData.toAddress?.address?.addressSelection?.masterContactAddressId?.masterContactId !== 0) {
          addressControl.patchValue({ ...defaultData.toAddress.address.addressSelection.masterContactAddressId });
        }

        this.onJobTypeChange(defaultData.containerBasics.jobType);
        this.onMtRequestDeliveryChange(defaultData.depotHub.mtRequestedDeliveryDate);
      }
    } else {
      this.containerJobDefault = null;
      this.formDefaultValues = null;
      this.setClearForm(true);
      this.isFormReady = true;
      this.applicationRef.tick();
    }
  }

  private setImportValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "toAddress.address",
      "division",
    ];

    this.setValidatorsFromList(formItems);
  }

  private setExportValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "fromAddress.address",
      "division",
    ];

    this.setValidatorsFromList(formItems);
  }

  private setDomesticInboundValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "toAddress.address",
      "division",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setDomesticOutboundValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "fromAddress.address",
      "division",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setRailInboundValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "toAddress.address",
      "division",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setRailOutboundValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "fromAddress.address",
      "division",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setIntermodalCoastalValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "division",

      "intermodalToPortData.originPort",
      "intermodalToPortData.vessel",
      "intermodalToPortData.fullRequestedDeliveryDate",
      "intermodalDivision",

      "fromAddress.address",

      "intermodalToAddress.address",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setIntermodalRailValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "portData.originPort",
      "portData.vessel",
      "portData.fullRequestedDeliveryDate",
      "division",
      "intermodalDivision",

      "intermodalToPortData.originPort",
      "intermodalToPortData.vessel",
      "intermodalToPortData.fullRequestedDeliveryDate",
      "fromAddress.address",
      "intermodalToAddress.address",
    ];
    this.setValidatorsFromList(formItems);
  }

  readonly baseControlsRequiringValidation = [
    "containerBasics.freightPayer",
    "containerBasics.jobType",
    "containerBasics.containerType",
    "containerBasics.containerSize",
    "containerBasics.orderNumber",
    "containerBasics.loadUnloadType",
    "containerBasics.billingDivision",
    "additionalData.firstNotifiedDate"
  ];

  private clearAllValidators(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const control = formGroup.get(key);
      if (control) {
        if (control instanceof FormGroup) {
          this.clearAllValidators(control);
        } else {
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
        }
      }
    });
  }

  private setRequiredValidators(formItems: string[], removeValidator: boolean = false) {
    this.clearAllValidators(this.createContainerJobForm);
    formItems.forEach((item) => {
      const control = this.createContainerJobForm.get(item);
      if (control) {
        if (removeValidator) {
          control.clearValidators();
        } else {
          control.setValidators([Validators.required]);
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private getConditionalValidators(formItems: string[]) {
    const condtionallyRequiredValidators = [
      {
        fromReference: 'depotHub.mtLocation',
        condition: () => {
          if (this.createContainerJobForm.get('containerBasics.fullLegOnly') && this.createContainerJobForm.get('containerBasics.jobType')) {
            if (this.createContainerJobForm.get('containerBasics.jobType')!.value === null
              || this.createContainerJobForm.get('containerBasics.jobType')!.value.id === JobTypeEnum.MoveMt
              || this.createContainerJobForm.get('containerBasics.jobType')!.value.id === JobTypeEnum.MoveFull
              || this.createContainerJobForm.get('containerBasics.jobType')!.value.id === JobTypeEnum.OnSite) {
              return false;
            }
            return !this.createContainerJobForm.get('containerBasics.fullLegOnly')!.value;
          } else {
            return false;
          }
        }
      },
      {
        fromReference: 'intermodalDepotHubData.mtLocation',
        condition: () => {
          if (this.isIntermodalJob() && this.createContainerJobForm.get('containerBasics.fullLegOnly') && this.createContainerJobForm.get('containerBasics.jobType')) {
            return !this.createContainerJobForm.get('containerBasics.fullLegOnly')!.value;
          } else {
            return false;
          }
        }
      },
      {
        fromReference: 'containerBasics.temperatureValue',
        condition: () => {
          if (this.createContainerJobForm.get('containerBasics.containerType')) {
            return this.createContainerJobForm.get('containerBasics.containerType')!.value.containerTypeId === 5;
          } else {
            return false;
          }
        }
      },
      {
        fromReference: 'portData.fromEtaEtdDate',
        condition: () => {
          if (this.createContainerJobForm.get('portData.vessel')) {
            const formValue = this.createContainerJobForm.get('portData.vessel')!.value;
            if (formValue) {
              return formValue.scheduledVesselVisitId !== 0;
            }
            return false;
          } else {
            return false;
          }
        }
      },
    ]

    condtionallyRequiredValidators.forEach((item) => {
      if (item.condition()) {
        formItems.push(item.fromReference);
      }
    })

    return formItems;
  }

  private setValidatorsFromList(itemsThatNeedRequiredValidators: string[]) {
    this.createContainerJobForm.clearValidators();
    this.createContainerJobForm.updateValueAndValidity();

    let formItems = this.getConditionalValidators(itemsThatNeedRequiredValidators);

    this.setRequiredValidators(formItems);
  }

  private setMoveValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "fromAddress.address",
      "toAddress.address",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setOnSiteValidators() {
    const formItems = [
      ...this.baseControlsRequiringValidation,
      "fromAddress.address",
    ];
    this.setValidatorsFromList(formItems);
  }

  private setOnlyBaseValidators() {
    this.setValidatorsFromList(this.baseControlsRequiringValidation);
  }

  private applyCorrectValidations(jobType: { id: number } | null = null) {
    if (jobType === null) {
      this.setOnlyBaseValidators();
      return;
    }

    switch (jobType.id) {
      case JobTypeEnum.Import:
        this.setImportValidators();
        break;
      case JobTypeEnum.Export:
        this.setExportValidators();
        break;
      case JobTypeEnum.DomesticInbound:
        this.setDomesticInboundValidators();
        break;
      case JobTypeEnum.DomesticOutbound:
        this.setDomesticOutboundValidators();
        break;
      case JobTypeEnum.RailInbound:
        this.setRailInboundValidators();
        break;
      case JobTypeEnum.RailOutbound:
        this.setRailOutboundValidators();
        break;
      case JobTypeEnum.IntermodalCoastal:
        this.setIntermodalCoastalValidators();
        break;
      case JobTypeEnum.IntermodalRail:
        this.setIntermodalRailValidators();
        break;
      case JobTypeEnum.MoveMt:
        this.setMoveValidators();
        break;
      case JobTypeEnum.MoveFull:
        this.setMoveValidators();
        break;
      case JobTypeEnum.OnSite:
        this.setOnSiteValidators();
        break;
      default:
        this.setOnlyBaseValidators();
        break;
    }
  }

  updateDefaults(defaultValue: any | null = null) {
    let containerBasicValues = defaultValue ? defaultValue.containerBasics : this.formDefaultValues.containerBasics;
    if (defaultValue) {
      defaultValue.attachments = [];
      defaultValue.bacc = [];
    }

    if (containerBasicValues && containerBasicValues.freightPayer) {
      const containerJobDefault: FormDefaultModel = {
        clienteleId: containerBasicValues.freightPayer.clienteleId,
        formValueJson: defaultValue ? JSON.stringify(defaultValue) : '{}',
        type: DefaultType.ContainerJob,
        userId: ''
      };

      this.formDefaultService.saveFormDefaults(containerJobDefault).subscribe({
        next: (response: any) => {
          if (response) {
            if (defaultValue) {
              this.toastr.show(
                {
                  text: "Default saved!",
                });
            } else {
              this.setClearForm(true);
              this.toastr.show({
                text: "Default removed!",
              });
            }
            this.containerJobDefault = response.body;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.showDanger(error.message + ' An error occurred');
        }
      });
    }
  }

  checkContainersGridValid(): boolean {
    if (this.gridStore.count < 1) {
      this.toastr.showDanger("Please add at least one container to the grid.");
      return false;
    }

    const allContainerNumbers = this.gridStore.map((item: GridRowItem) => item.containerNumber)
      .filter(containerNumber => containerNumber !== '');

    if (this.CanSkipContainerNumber() && allContainerNumbers.join().length === 0) {
      return true;
    }

    let uniqueContainerNumbers = Array.from(new Set(this.gridStore.map((item: GridRowItem) => item.containerNumber)));

    if (this.CanSkipContainerNumber()) {
      uniqueContainerNumbers = uniqueContainerNumbers.filter(containerNumber => containerNumber !== '');
    }

    if (allContainerNumbers.length !== uniqueContainerNumbers.length) {
      this.toastr.showDanger("All container numbers must be unique.");
      return false;
    }

    for (let containerNumber of uniqueContainerNumbers) {
      if (ContainerNumberHelper.containerNumberIsValid(containerNumber) !== true) {
        this.toastr.showDanger(`Container number ${containerNumber} is invalid.`);
        return false;
      }
    }

    return true;
  }

  private async convertFilesToUploadAttachments(files: File[]): Promise<UploadAttachment[]> {
    const attachmentsToUpload: UploadAttachment[] = await Promise.all(
      files.map(async (file) => {
        const fileContents = await this.downloadBlobService.readFileAsBase64(file);
        return {
          name: file.name,
          contentType: file.type,
          data: fileContents,
          attachmentType: ""
        };
      })
    );

    return attachmentsToUpload;
  }

  async onCreateContainerJob() {
    this.createContainerJobForm.markAllAsTouched();
    this.createContainerJobForm.updateValueAndValidity();

    if (this.createContainerJobForm.invalid) {
      const errors = this.getAllErrors(this.createContainerJobForm);
      if (errors.length === 0) {
        this.toastr.showDanger("Please fix validation errors before continuing.");
      }

      for (const error of errors) {
        this.toastr.showDanger(error);
      }

      return;
    }

    if (!this.checkContainersGridValid()) {
      this.toastr.showDanger("Please ensure configured container information is correct.");
      return;
    }

    this.isSaving = true;

    const factory = new CreateContainerJobRequestFactory();
    const rows = this.gridStore.allRecords;
    const request = factory.buildContainerJobRequest(this.createContainerJobForm, rows, this.googleMapsService);

    if (this.createContainerJobForm.value.attachments && this.createContainerJobForm.value.attachments.length > 0) {
      request.attachments = await this.convertFilesToUploadAttachments(this.createContainerJobForm.value.attachments);
    }

    if (this.createContainerJobForm.value.bacc && this.createContainerJobForm.value.bacc.length > 0) {
      request.bacc = await this.convertFilesToUploadAttachments(this.createContainerJobForm.value.bacc);
    }
    
    this.containerService.createContainerJob(request).subscribe({
      next: (response) => {
        if (!response.ok) {
          this.toastr.showDanger("The container job could not be created. Could not create container job.");
          this.isSaving = false;
        } else {
          this.toastr.showDefault("Container job has been created. Container job created.");
          this.resetPage();
          this.isSaving = false;
        }
      },
      error: (errorResponse: HttpErrorResponse) => {
        this.toastr.showDanger("There was an error. We could not create the container job.");
        this.isSaving = false;
      }
    });
  }

  resetPage() {
    this.setClearForm();
    this.gridStore.removeAll();
  }

  onClickAddContainers() {
    if (this.createContainerJobForm.valid) {
      this.addBulkContainers();
    } else {
      const errors = this.getAllErrors(this.createContainerJobForm);
      errors.forEach((error: string) => {
        this.toastr.showDanger(error);
      });
    }
  }

  addBulkContainers() {
    const modalRef = this.modalService.open(BulkUpsertItemsComponent, {});

    modalRef.closed.subscribe((data: { formGroup: FormGroup, containerNumbers: string[] }) => {
      const formGroupValue = data.formGroup.getRawValue();
      const containerCount = data.containerNumbers.length;
      const direction = formGroupValue.doorDirection.name;
      let count = formGroupValue.ctrCount;

      if (containerCount > count) {
        count = containerCount;
      }

      for (let i = 0; i < count; i++) {

        let containerNumber = '';
        if (data.containerNumbers) {
          containerNumber = data.containerNumbers[i];
        }

        this.insertNewRow(direction, containerNumber, i);
      }
    });
  }

  insertNewRow(direction: string, containerNumber: string, count: number) {
    const basics = this.createContainerJobForm.value.containerBasics;
    const devanDate = DateHelper.parse(this.createContainerJobForm.value.plannedDevanDate, ParseStrings.bryntumDbDate);
    const devanType = this.createContainerJobForm.value.plannedDevanType ? this.createContainerJobForm.value.plannedDevanType.name : '';
    const packDate = DateHelper.parse(this.createContainerJobForm.value.plannedPackDate, ParseStrings.bryntumDbDate);
    const packType = this.createContainerJobForm.value.plannedPackType ? this.createContainerJobForm.value.plannedPackType.name : '';

    const billingValue = this.createContainerJobForm.value?.containerCharges?.totalPerContainerValue
      ? this.createContainerJobForm.value.containerCharges.value.totalPerContainerValue
      : '';

    const surchargeValue = this.createContainerJobForm.value?.containerSurcharges
      ? this.createContainerJobForm.value.containerSurcharges
      : '';

    let hazmatCode: string = '';
    if (this.createContainerJobForm.value.additionalData &&
      this.createContainerJobForm.value.additionalData.isHazmat &&
      this.createContainerJobForm.value.additionalData.hazmatCode) {
      hazmatCode = this.createContainerJobForm.value.additionalData.hazmatCode.name;
    }

    let paddedNum = this.CanSkipContainerNumber() ? "" : `CNTR${String(count + 1).padStart(5, '0')}`;

    let gridRowItem: GridRowItem = {
      containerNumber: containerNumber ? containerNumber : paddedNum,
      orderNumber: basics.orderNumber,
      customerReference: basics.customerReference,
      csrComments: basics.csrComments,
      billingNotes: basics.billingNotes,
      weight: 0,
      containerType: basics.containerType.code,
      containerSize: basics.containerSize.code,
      devanDate: devanDate,
      devanType: devanType,
      packDate: packDate,
      packType: packType,
      loadDate: '',
      doorDirection: direction,
      storageDays: 0,
      pin: null,
      expressPin: null,
      dangerousGoods: hazmatCode,
      mpi: basics.mpiInspectionRequired,
      seal: '',
      liveLoad: basics.loadUnloadType.code,
      useHubs: this.getFormattedHubLabel(),
      billingValue: billingValue,
      billingData: new BillingData(),
      surchargeValue: surchargeValue,
      surcharges: this.createContainerJobForm.value.containerSurcharges,
      isHighGauge: basics.isHighGauge,
      isWideGauge: basics.isWideGauge,
      requiresXray: basics.requiresXray,
      requiresWeigh: basics.requiresWeigh,
      gridNumberFull: '',
      gridNumberMt: '',
    };

    this.gridStore.add(gridRowItem);
  }

  getFormattedHubLabel(): string {
    let result = '';
    const hubs = this.createContainerJobForm.value.depotHub;
    if (!hubs) {
      return result;
    }

    if (hubs.inboundHub && hubs.inboundHub.id > 0) {
      result += 'IN';
    }

    if (hubs.inboundHub && hubs.inboundHub.id > 0 && hubs.outboundHub && hubs.outboundHub.id > 0) {
      result += ' + ';
    }

    if (hubs.outboundHub && hubs.outboundHub.id > 0) {
      result += 'OUT';
    }

    return result;
  }

  validationMessages: any = {
    'containerBasics.freightPayer': {
      'required': 'Freight payer must be selected',
    },
    'containerBasics.orderNumber': {
      'required': 'Order number must be entered',
    },
    'containerBasics.temperatureValue': {
      'required': 'Temperature must be set for refrigerated containers'
    },
    'containerBasics.jobType': {
      'required': 'Job type must be selected',
    },
    'containerBasics.containerType': {
      'required': 'Container type must be selected',
    },
    'containerBasics.containerSize': {
      'required': 'Container size must be selected',
    },
    'containerCharges.description': {
      'required': 'Container charge must have description set',
    },
    'containerCharges.ratePerContainer': {
      'required': 'Container charge must have rate set',
    },
    'containerCharges.fafRate': {
      'required': 'Container charge must have a FAF rate',
    },
    'containerSurcharges.surcharges.taskType': {
      'required': 'All surcharges must have a type',
    },
    'containerSurcharges.surcharges.units': {
      'required': 'All surcharges must have units set',
    },
    'containerSurcharges.surcharges.rate': {
      'required': 'All surcharges must have a rate',
    },
    'containerSurcharges.surcharges.fafRate': {
      'required': 'All surcharges must have a FAF rate',
    },
    'depotHub.mtLocation': {
      'required': 'MT Dehire Point must be selected',
    },
    'depotHub.mtRequestedDeliveryDate': {
      'required': 'MT Requested Delivery Date must be selected',
      'dateNotLess': 'MT Requested Delivery Date must be after Full Requested Delivery Date',
    },
    'portData.fromEtaEtdDate': {
      'required': 'Vessel ETA must be selected',
    },
    'portData.vessel': {
      'required': 'Vessel must be selected',
    },
    'portData.fullRequestedDeliveryDate': {
      'required': 'Full Requested Delivery Date must be selected',
      'dateNotLess': 'Full Requested Delivery Date must be after Vessel ETA',
    },
    'portData.originPort': {
      'required': 'Origin Port must be selected',
    },
    'toAddress.address.addressSelection.masterContactAddressId': {
      'required': 'To Address must be selected',
    },
    'fromAddress.address': {
      'required': 'From Address must be selected',
    },
    'containerBasics.billingDivision': {
      'required': 'Billing Division must be selected',
    },
    'containerBasics.loadUnloadType': {
      'required': 'Is Live value must be selected',
    },
    'additionalData.hazmatCode': {
      'required': 'Hazmat code must be selected',
    },
    'intermodalDepotHubData.mtLocation': {
      'required': 'Intermodal Dehire point must be selected',
    },
    'intermodalToPortData.originPort': {
      'required': 'Intermodal origin port must be selected',
    },
    'intermodalToPortData.fromEtaEtdDate': {
      'required': 'Intermodal vessel ETA must be selected',
    },
    'intermodalToPortData.vessel': {
      'required': 'Intermodal vessel must be selected',
    },
    'intermodalToPortData.fullRequestedDeliveryDate': {
      'required': 'Intermodal Full Requested Delivery date must be selected',
    },
    'intermodalToAddress.address': {
      'required': 'Intermodal to address must be selected',
    },
    'intermodalDivision': {
      'required': 'Division must be set for the arriving leg of an intermodal job',
    },
    'Division': {
      'required': 'Division must be set',
    },
    'plannedDevanDate': {
      'required': 'Planned Devan Date must be set',
      'dateNotLess': 'Planned Devan Date must be after Full Requested Delivery Date',
    },
    'plannedDevanType': {
      'required': 'Devan Type must be set',
    },
    'plannedPackDate': {
      'required': 'Planned Pack Date must be set',
    },
    'plannedPackType': {
      'required': 'Pack Type must be set',
    },
    'attachments': {
      'invalidFileTypes': 'Attachments contain unsupported file types',
    },
    'bacc': {
      'invalidFileTypes': 'BACC/Compliance documents contain unsupported file types',
    }
  };

  getAllErrors(form: FormGroup, baseControlName: string = '') {
    let messages: string[] = [];
    for (const currentControlName in form.controls) {
      const controlKey = `${baseControlName}${baseControlName !== '' ? '.' : ''}${currentControlName}`;
      if (form.controls.hasOwnProperty(currentControlName)) {
        const c = form.controls[currentControlName];
        // If it is a FormGroup, process its child controls.
        if (c instanceof FormGroup) {
          messages = [...messages, ...this.getAllErrors(c, controlKey)];
        } else if (c instanceof FormArray) {
          for (let i = 0; i < c.length; i++) {
            messages = [...messages, ...this.getAllErrors(c.at(i) as FormGroup, controlKey)];
          }
        } else {
          // Only validate if there are validation messages for the control
          if (this.validationMessages[controlKey]) {
            if (c.errors) {
              Object.keys(c.errors).map(messageKey => {
                if (this.validationMessages[controlKey][messageKey]) {
                  messages.push(this.validationMessages[controlKey][messageKey]);
                }
              });
            }
          } else {
            if (c.errors) {
              messages.push(controlKey + ' is invalid');
            }
          }
        }
      }
    }
    return messages;
  }
}
